module.exports = __webpack_public_path__ + "static/imagem-02-home-50d95b403c39b0ad3922c74a8aafc699.jpg";